import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio, Select } from 'antd';
import PropTypes from 'prop-types';
import { getClientMessages, getRegistrationMessages } from '../../../constants/messages';

let regMessages = getRegistrationMessages(),
	clientMessages = getClientMessages();

const messages = {
	...regMessages,
	...clientMessages,
};

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Option } = Select;

export const SORT_OPTIONS = {
	NAME_ASC: 'name_asc',
	DEVICES_DESC: 'devices_desc',
	NEXT_INVOICE_DESC: 'next_invoice_desc',
};

const ClientRadioButton = ({ onSortChange }) => {
	const [sortBy, setSortBy] = React.useState(SORT_OPTIONS.NAME_ASC);
	const [disabled, setDisabled] = React.useState(0);

	const onStatusChange = (e) => {
		const newDisabled = e.target.value;
		setDisabled(newDisabled);
		if (onSortChange) onSortChange({ disabled: newDisabled, sortBy });
	};

	const onSortSelect = (value) => {
		setSortBy(value);
		if (onSortChange) onSortChange({ disabled, sortBy: value });
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
			<RadioGroup onChange={onStatusChange} defaultValue={0}>
				<RadioButton value={0}>
					<FormattedMessage {...messages.all} />
				</RadioButton>
				<RadioButton value={false}>
					<FormattedMessage {...messages.enabled} />
				</RadioButton>
				<RadioButton value={true}>
					<FormattedMessage {...messages.disabled} />
				</RadioButton>
			</RadioGroup>

			<Select value={sortBy} onChange={onSortSelect} style={{ minWidth: 200 }}>
				<Option value={SORT_OPTIONS.NAME_ASC}>
					<FormattedMessage {...messages.sortByName} />
				</Option>
				<Option value={SORT_OPTIONS.DEVICES_DESC}>
					<FormattedMessage {...messages.sortByDevices} />
				</Option>
				<Option value={SORT_OPTIONS.NEXT_INVOICE_DESC}>
					<FormattedMessage {...messages.nextInvoiceMonth} />
				</Option>
			</Select>
		</div>
	);
};

ClientRadioButton.propTypes = {
	onSortChange: PropTypes.func,
};

export default ClientRadioButton;
